import { PropsWithChildren } from 'react';

import { ExternalCell, Stack } from '@cast/design-system';
import { WorkloadEventType } from '@cast/types';

import { ScalingPolicyEvent } from 'features/cluster/workload-optimization/types';

import { DetailsRowContainer, DetailWitTitle } from './DetailsRowContainer';

export const ScalingPolicyEventDetailsRowContainer = ({
  event,
  children,
}: PropsWithChildren<{
  event: ScalingPolicyEvent;
}>) => {
  const assignedWorkloads = !!event.workloads &&
    event.type !== WorkloadEventType.SCALING_POLICY_DELETED && (
      <DetailWitTitle
        title="WORKLOADS ASSIGNED:"
        detail={event.workloads.length}
        titleVariant="strong"
      />
    );

  const height = assignedWorkloads ? 104 : 76;

  const policyName =
    event.type === WorkloadEventType.SCALING_POLICY_UPDATED
      ? event.details.current.name
      : event.details.policy.name;

  return (
    <DetailsRowContainer
      event={event}
      titleRowProps={{ height, sx: { alignItems: 'flex-start' }, py: 16 }}
      titleRowContent={
        <ExternalCell startColumn={1} cellProps={{ width: '100%' }}>
          <Stack gap={12} width="100%">
            <DetailWitTitle
              title="Vertical Scaling Policy:"
              detail={policyName}
              titleVariant="strong"
            />
            {assignedWorkloads}
            <DetailWitTitle
              title="Initiated by:"
              detail={event.initiatedBy?.email}
              titleVariant="strong"
            />
          </Stack>
        </ExternalCell>
      }
    >
      {children}
    </DetailsRowContainer>
  );
};
